import {
  POSTALCODE_COUNTRIES_FETCH,
  POSTALCODE_PROVINCES_FETCH,
  POSTALCODE_CITIES_FETCH,
  COURIERS_COST_POST,
  SHIPPING_POST,
  HISTORY_SHIPPING_UPDATE,
  USER_HISTORY_SHIPPING,
  USER_SIZES_FETCH,
  USER_SIZE_POST,
  USER_SIZE_UPDATE,
  USER_BANK_ACCOUNT_FETCH,
  USER_BANK_ACCOUNT_POST,
  USER_BANK_ACCOUNT_UPDATE,
  SIZES_FETCH,
  PROMISE_PENDING,
  PROMISE_REJECTED,
  PROMISE_FULFILLED,
  COURIER_PRICE_KEY,
  FETCH_ALL_COURIER,
  FETCH_DISTRICT,
  POST_PICKUP_IDEXPRESS,
  PASSING_SALE_ID_EXPRESS,
  ALLOWED_PICKUP_IDEXPRESS,
  POST_CANCEL_PICKUP_IDEXPRESS,
  GET_BANK_LIST
} from '../constants/';
import moment from 'moment';
import { concatShippingId } from '../actions/postalCodeAction';

const defaultError = {
  error: {
    message: 'I got something undefined errors',
    status_code: 500
  }
}

const initialState = {
  countries: {
    data: [],
    isFetch: false,
    error: null
  },
  district: {
    data: [],
    isFetch: false,
    error: null
  },
  provinces: {
    data: [],
    isFetch: false,
    error: null
  },
  cities: {
    data: [],
    isFetch: false,
    error: null
  },
  couriers: {
    cost: 0,
    isFetch: false,
    error: null,
    list: []
  },
  shippingHistory: {
    data: [],
    isFetch: false,
    error: null
  },
  userSizes: {
    data: [],
    isFetch: false,
    error: null
  },
  updatedUserSizes: {
    status_code: 0,
    message: '',
    isFetch: false,
    error: null
  },
  userBankAccount: {
    data: [],
    isFetch: false,
    error: null
  },
  updatedUserBankAccount: {
    status_code: 0,
    message: '',
    isFetch: false,
    error: null
  },
  sizes: {
    data: [],
    isFetch: false,
    error: null
  },
  shippingProcessed: {
    data: [],
    status_code: 0,
    message: '',
    isSubmit: false,
    error: null
  },
  idExpressPickUpProcess: {
    // data: [],
    status_code: 0,
    message: '',
    isSubmit: false,
    error: null,
    data: {}
  },
  cancelIdExpressPickUpProcess: {
    status_code: 0,
    message: '',
    isSubmit: false,
    error: null
  },
  dataSaleForIdExpress: {
    data: []
  },
  bankList: {
    isFetch: false,
    data: [],
    error: null,
    status_code: null
  }
}

const onError = err => {
  return (err.response !== null && err.response !== undefined) ?
    { ...err.response.data, data: [] }
    : { ...defaultError, data: [] };
}

const onProsesShippingSuccess = (lastState, payload) => {
  const { data, isNew } = payload;
  const { shippingHistory, shippingProcessed } = lastState;
  if (!isNew) {
    const list = shippingHistory.data.map(shipping => {
      if (shipping.id === data.id) return { ...data }
      return shipping;
    })
    shippingHistory.data = list;
  } else {
    shippingHistory.data.push(data);
  }

  return {
    ...lastState,
    shippingHistory: { ...shippingHistory },
    shippingProcessed: {
      ...lastState.shippingProcessed,
      ...payload,
      isSubmit: false,
      error: null
    }
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `RESET_BANK_ADDRESS`: return {
      ...state, userBankAccount: {
        data: [],
        isFetch: false,
        error: null
      },
      shippingHistory: {
        data: [],
        isFetch: false,
        error: null
      },
    }
    case `${POSTALCODE_COUNTRIES_FETCH}${PROMISE_PENDING}`:
      return { ...state, countries: { ...state.countries, isFetch: true } }
    case `${POSTALCODE_COUNTRIES_FETCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return { ...state, countries: { ...state.countries, data, status_code, message, isFetch: false, error: null } }
    }
    case `${POSTALCODE_COUNTRIES_FETCH}${PROMISE_REJECTED}`: {
      return { ...state, countries: { ...state.countries, isFetch: false, ...onError(action.payload) } }
    }
    case `${FETCH_DISTRICT}${PROMISE_PENDING}`:
      return { ...state, district: { ...state.district, isFetch: true } }
    case `${FETCH_DISTRICT}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return { ...state, district: { ...state.district, data, status_code, message, isFetch: false, error: null } }
    }
    case `${FETCH_DISTRICT}${PROMISE_REJECTED}`: {
      return { ...state, district: { ...state.district, isFetch: false, ...onError(action.payload) } }
    }

    case `${POSTALCODE_PROVINCES_FETCH}${PROMISE_PENDING}`:
      return { ...state, provinces: { ...state.provinces, data: [], isFetch: true, status_code: 0 } }
    case `${POSTALCODE_PROVINCES_FETCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return { ...state, provinces: { ...state.provinces, data, status_code, message, isFetch: false, error: null } }
    }
    case `${POSTALCODE_PROVINCES_FETCH}${PROMISE_REJECTED}`: {
      return { ...state, provinces: { ...state.provinces, isFetch: false, ...onError(action.payload) } }
    }
    case `${POSTALCODE_CITIES_FETCH}${PROMISE_PENDING}`:
      return { ...state, cities: { ...state.cities, data: [], isFetch: true } }
    case `${POSTALCODE_CITIES_FETCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return { ...state, cities: { ...state.cities, data, status_code, message, isFetch: false, error: null } }
    }
    case `${POSTALCODE_CITIES_FETCH}${PROMISE_REJECTED}`: {
      return { ...state, cities: { ...state.cities, isFetch: false, ...onError(action.payload) } }
    }
    case `${FETCH_ALL_COURIER}${PROMISE_PENDING}`:
      return { ...state, couriers: { ...state.couriers, isFetch: true } }
    case `${FETCH_ALL_COURIER}${PROMISE_FULFILLED}`:
      return { ...state, couriers: { ...state.couriers, isFetch: false, list: action.payload } }
    case `${COURIERS_COST_POST}${PROMISE_PENDING}`:
      return { ...state, couriers: { ...state.couriers, isFetch: true } }
    case `${COURIERS_COST_POST}${PROMISE_FULFILLED}`: {
      const { data, status_code, message, country, destination, courier, weight, product_variant_id, isNew } = action.payload;
      if (isNew) {
        const getLocalCourierStr = localStorage.getItem(COURIER_PRICE_KEY);
        let getLocalCourierList = [];
        if (getLocalCourierStr && getLocalCourierStr !== '') {
          getLocalCourierList = (JSON.parse(atob(getLocalCourierStr)) || [])
            .filter(item => item.last_fetched && moment().diff(item.last_fetched, 'minutes') < 30);
        }
        localStorage.setItem(COURIER_PRICE_KEY,
          btoa(JSON.stringify([
            ...getLocalCourierList,
            { id: concatShippingId({ country, destination, courier, weight, product_variant_id }), data, message, status_code, last_fetched: new Date() }
          ]))
        )
      }
      return { ...state, couriers: { ...state.couriers, cost: data, status_code, message, isFetch: false, error: null } }
    }
    case `${COURIERS_COST_POST}${PROMISE_REJECTED}`: {
      return { ...state, couriers: { ...state.couriers, isFetch: false, ...onError(action.payload) } }
    }
    case `${SHIPPING_POST}${PROMISE_PENDING}`:
      return { ...state, shippingProcessed: { ...state.shippingProcessed, isSubmit: true } }
    case `${SHIPPING_POST}${PROMISE_FULFILLED}`: {
      return onProsesShippingSuccess(state, action.payload);
    }
    case `${SHIPPING_POST}${PROMISE_REJECTED}`: {
      return { ...state, shippingProcessed: { ...state.shippingProcessed, isSubmit: false, ...onError(action.payload) } }
    }
    case `${HISTORY_SHIPPING_UPDATE}${PROMISE_PENDING}`:
      return { ...state, shippingProcessed: { ...state.shippingProcessed, isSubmit: true } }
    case `${HISTORY_SHIPPING_UPDATE}${PROMISE_FULFILLED}`: {
      return onProsesShippingSuccess(state, action.payload);
    }
    case `${HISTORY_SHIPPING_UPDATE}${PROMISE_REJECTED}`: {
      const { status_code, message } = action.payload.response.data.error;
      return { ...state, shippingProcessed: { ...state.shippingProcessed, isSubmit: false, ...onError(action.payload), status_code, message } }
    }
    case `${USER_BANK_ACCOUNT_POST}${PROMISE_PENDING}`:
      return { ...state, updatedUserBankAccount: { ...state.updatedUserBankAccount, isFetch: true, status_code: null } }
    case `${USER_BANK_ACCOUNT_POST}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload
      const newData = [{ ...data }];
      // console.log('balikan post user bank account', newData);
      return { ...state, updatedUserBankAccount: { ...state.updatedUserBankAccount, status_code, message, isFetch: false, error: null }, userBankAccount: { ...state.userBankAccount, data: newData, status_code, message, isFetch: false, error: null } }
    }
    case `${USER_BANK_ACCOUNT_POST}${PROMISE_REJECTED}`: {
      const { status_code, message } = action.payload.response.data.error;
      return { ...state, updatedUserBankAccount: { ...state.updatedUserBankAccount, isFetch: false, ...onError(action.payload), status_code, message } }
    }
    case `${USER_BANK_ACCOUNT_UPDATE}${PROMISE_PENDING}`:
      return { ...state, updatedUserBankAccount: { ...state.updatedUserBankAccount, isFetch: true } }
    case `${USER_BANK_ACCOUNT_UPDATE}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      const newData = [{ ...data }];
      return { ...state, updatedUserBankAccount: { ...state.updatedUserBankAccount, status_code, message, isFetch: false, error: null }, userBankAccount: { ...state.userBankAccount, data: newData, status_code, message, isFetch: false, error: null } }
    }
    case `${USER_BANK_ACCOUNT_UPDATE}${PROMISE_REJECTED}`: {
      const { status_code, message } = action.payload.response.data.error;
      return { ...state, updatedUserBankAccount: { ...state.updatedUserBankAccount, isFetch: false, ...onError(action.payload), status_code, message } }
    }
    case `${USER_SIZES_FETCH}${PROMISE_PENDING}`:
      return { ...state, userSizes: { ...state.userSizes, isFetch: true } }
    case `${USER_SIZES_FETCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload
      return { ...state, userSizes: { ...state.userSizes, data, status_code, message, isFetch: false, error: null } }
    }
    case `${USER_SIZES_FETCH}${PROMISE_REJECTED}`: {
      return { ...state, userSizes: { ...state.userSizes, isFetch: false, ...onError(action.payload) } }
    }
    case `${USER_SIZE_POST}${PROMISE_PENDING}`:
      return { ...state, updatedUserSizes: { ...state.updatedUserSizes, isFetch: true } }
    case `${USER_SIZE_POST}${PROMISE_FULFILLED}`: {
      const { status_code, message } = action.payload
      return { ...state, updatedUserSizes: { ...state.updatedUserSizes, status_code, message, isFetch: false, error: null } }
    }
    case `${USER_SIZE_POST}${PROMISE_REJECTED}`: {
      const { status_code, message } = action.payload.response.data.error;
      return { ...state, updatedUserSizes: { ...state.updatedUserSizes, isFetch: false, ...onError(action.payload), status_code, message } }
    }
    case `${USER_SIZE_UPDATE}${PROMISE_PENDING}`:
      return { ...state, updatedUserSizes: { ...state.updatedUserSizes, isFetch: true } }
    case `${USER_SIZE_UPDATE}${PROMISE_FULFILLED}`: {
      const { status_code, message } = action.payload
      return { ...state, updatedUserSizes: { ...state.updatedUserSizes, status_code, message, isFetch: false, error: null } }
    }
    case `${USER_SIZE_UPDATE}${PROMISE_REJECTED}`: {
      const { status_code, message } = action.payload.response.data.error;
      return { ...state, updatedUserSizes: { ...state.updatedUserSizes, isFetch: false, ...onError(action.payload), status_code, message } }
    }
    case `${USER_BANK_ACCOUNT_FETCH}${PROMISE_PENDING}`:
      return { ...state, userBankAccount: { ...state.userBankAccount, isFetch: true } }
    case `${USER_BANK_ACCOUNT_FETCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload
      return { ...state, userBankAccount: { ...state.userBankAccount, data, status_code, message, isFetch: false, error: null } }
    }
    case `${USER_BANK_ACCOUNT_FETCH}${PROMISE_REJECTED}`: {
      return { ...state, userBankAccount: { ...state.userBankAccount, isFetch: false, ...onError(action.payload) } }
    }
    case `${SIZES_FETCH}${PROMISE_PENDING}`:
      return { ...state, sizes: { ...state.sizes, isFetch: true } }
    case `${SIZES_FETCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload
      return { ...state, sizes: { ...state.sizes, data, status_code, message, isFetch: false, error: null } }
    }
    case `${SIZES_FETCH}${PROMISE_REJECTED}`: {
      return { ...state, sizes: { ...state.sizes, isFetch: false, ...onError(action.payload) } }
    }
    case `${USER_HISTORY_SHIPPING}${PROMISE_PENDING}`: {
      return { ...state, shippingHistory: { ...state.shippingHistory, isFetch: true } }
    }
    case `${USER_HISTORY_SHIPPING}${PROMISE_REJECTED}`: {
      return { ...state, shippingHistory: { ...state.shippingHistory, isFetch: false, ...onError(action.payload) } }
    }
    case `${USER_HISTORY_SHIPPING}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload
      return { ...state, shippingHistory: { ...state.shippingHistory, data, status_code, isFetch: false, error: null } }
    }

    case `${POST_PICKUP_IDEXPRESS}${PROMISE_PENDING}`: {
      return { ...state, idExpressPickUpProcess: { ...state.idExpressPickUpProcess, isSubmit: true } }
    }
    case `${POST_PICKUP_IDEXPRESS}${PROMISE_REJECTED}`: {
      return { ...state, idExpressPickUpProcess: { ...state.idExpressPickUpProcess, isSubmit: false, ...onError(action.payload) } }
    }
    case `${POST_PICKUP_IDEXPRESS}${PROMISE_FULFILLED}`: {
      const { status_code, message, data } = action.payload
      return { ...state, idExpressPickUpProcess: { ...state.idExpressPickUpProcess, data, status_code, isSubmit: false, message, error: null } }
    }

    case `${POST_CANCEL_PICKUP_IDEXPRESS}${PROMISE_PENDING}`: {
      return { ...state, idExpressPickUpProcess: { ...state.cancelIdExpressPickUpProcess, isSubmit: true } }
    }
    case `${POST_CANCEL_PICKUP_IDEXPRESS}${PROMISE_REJECTED}`: {
      return { ...state, cancelIdExpressPickUpProcess: { ...state.cancelIdExpressPickUpProcess, isSubmit: false, ...onError(action.payload) } }
    }
    case `${POST_CANCEL_PICKUP_IDEXPRESS}${PROMISE_FULFILLED}`: {
      const { status_code, message } = action.payload
      return { ...state, cancelIdExpressPickUpProcess: { ...state.cancelIdExpressPickUpProcess, status_code, isSubmit: false, message, error: null } }
    }

    case `${PASSING_SALE_ID_EXPRESS}`: {
      return { ...state, dataSaleForIdExpress: { ...state.dataSaleForIdExpress, data: action.payload } }
    }
    case `${ALLOWED_PICKUP_IDEXPRESS}${PROMISE_FULFILLED}`: {
      const { data } = action.payload;

      if (data.data.length > 0 && data.data[0].name === 'idexpress') {
        return { ...state, isEnabledPickupIdExpress: data.data[0].active }
      }
      return { ...state, isEnabledPickupIdExpress: false }
    }
    case `${ALLOWED_PICKUP_IDEXPRESS}${PROMISE_REJECTED}`: {
      return { ...state, isEnabledPickupIdExpress: false }
    }

    case `${GET_BANK_LIST}${PROMISE_PENDING}`:
      return {
        ...state,
        bankList: {
          ...state.bankList,
          isFetch: true,
          error: null
        }
      }
    case `${GET_BANK_LIST}${PROMISE_FULFILLED}`:
      return {
        ...state,
        bankList: {
          ...state.bankList,
          isFetch: false,
          data: action.payload.data,
          error: null,
          status_code: 200
        }
      }
    case `${GET_BANK_LIST}${PROMISE_REJECTED}`:
      return {
        ...state,
        bankList: {
          ...state.bankList,
          isFetch: false,
          error: action.payload.data
        }
      }

    default: return state;
  }
}
export default reducer;
